import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DCLoadingComponent } from './loading.component';



@NgModule({
  declarations: [
    DCLoadingComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [
    DCLoadingComponent
  ],
  exports: [
    DCLoadingComponent
  ]
})
export class DCLoadingModule { }
